import { createFileRoute } from "@tanstack/react-router";
import {
    selectFormsQueryOptions,
} from "../../../features/forms/api/selectForms";
import { FormsTable } from "../../../features/forms/components/FormsTable";

export const Route = createFileRoute("/public/form/")({
    component: () => {
        const { forms } = Route.useLoaderData();
        return (
            <section className="p-2 md:p-4">
                {forms && <FormsTable forms={forms} />}
            </section>
        );
    },
    loader: async ({ context }) => {
        const forms = await context.queryClient.ensureQueryData(
            selectFormsQueryOptions(),
        );
        return { forms };
    },
});
